import type { StagedUpload } from '@core/entities/UploadedFile';
import type { UploadRepository } from '@core/repositories/UploadRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';

interface UploadedFileResponse {
  id: string;
  filename: string;
  mime_type: string | null;
  size: number;
}

export class UploadRepositoryImpl implements UploadRepository {
  async upload(
    file: File,
    onProgress?: (percent: number) => void,
    signal?: AbortSignal,
  ): Promise<StagedUpload> {
    try {
      const form = new FormData();
      form.append('file', file);
      const response = await httpClient.post<{ data: UploadedFileResponse }>('/uploads', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        signal,
        onUploadProgress: (event) => {
          if (!onProgress || !event.total) return;
          onProgress(Math.round((event.loaded / event.total) * 100));
        },
      });
      const payload = response.data.data;
      return {
        id: payload.id,
        filename: payload.filename,
        mimeType: payload.mime_type,
        size: payload.size,
      };
    } catch (error) {
      throw toAppError(error);
    }
  }

  async remove(id: string): Promise<void> {
    try {
      await httpClient.delete(`/uploads/${id}`);
    } catch (error) {
      throw toAppError(error);
    }
  }
}
